import { httpApps } from "../helper/http-common";

class ChooseSettingServices {
  PendantBuilderLoadStud(inputData) {
    return httpApps.post("PendantBuilder/PendantBuilderLoadStud", inputData);
  }
}

export default new ChooseSettingServices();
